// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"383":"0a33f88e","535":"a08c913b","548":"f8617874","639":"c7130087","870":"ecaa9e10","884":"f20f3df9","942":"bbfe4509"}[chunkId] + ".js";
};